import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-987d45e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-testid": "step-confirmPhone",
  class: "container step-confirm-phone"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "step-confirm-phone__info" }
const _hoisted_4 = { class: "step-confirm-phone__info" }
const _hoisted_5 = { class: "row row--account-validation-get-data" }
const _hoisted_6 = { class: "row row--account-validation-get-data__phone-number" }
const _hoisted_7 = { class: "row--account-validation-get-sms-code" }
const _hoisted_8 = { class: "row--account-validation-get-sms-code__input" }
const _hoisted_9 = { class: "confirm-phone-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneField = _resolveComponent("PhoneField")!
  const _component_RecaptchaButton = _resolveComponent("RecaptchaButton")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneNumber`)), 1),
    (!_ctx.isSmsSent)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneVerify`)) + " " + _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneVerifyInfo`)), 1),
          _createElementVNode("div", {
            class: "row row--account-validation-get-data",
            style: _normalizeStyle({ 'margin-bottom': _ctx.isSmsSent ? '0' : '-25px' })
          }, [
            _createVNode(_component_PhoneField, {
              ref: "phoneNumberInput",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => (_ctx.phone = $event)),
                _cache[1] || (_cache[1] = ($event) => _ctx.updatePhone($event))
              ],
              name: "phoneNumber",
              "cy-data": "phone-number",
              placeholder: 
                        _ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneNumberPlaceholder`)
                    
            }, null, 8, ["modelValue", "placeholder"])
          ], 4),
          _createVNode(_component_RecaptchaButton, {
            action: _ctx.Action.DESKTOP_SMS,
            data: _ctx.formData,
            "button-value": _ctx.$t(`${_ctx.TRANSLATION_KEY}.confirmPhoneNumber`),
            "data-testid": "btn-confirmPhone-confirmPhoneNumber",
            class: "button submit-button",
            style: _normalizeStyle({ top: _ctx.isSmsSent ? '0' : '25px' }),
            disabled: _ctx.formData.phoneNumber.length < 5,
            onSuccessSubmit: _ctx.handleSubmitSuccess
          }, null, 8, ["action", "data", "button-value", "style", "disabled", "onSuccessSubmit"])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.isSmsSent)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          id: "confirm-phone",
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneVerify`)) + " " + _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneVerifyInfo`)), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_PhoneField, {
                ref: "phoneNumberInput",
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.phone = $event)),
                name: "phoneNumber",
                "cy-data": "phone-number",
                placeholder: 
                            _ctx.$t(`${_ctx.TRANSLATION_KEY}.phoneNumberPlaceholder`)
                        ,
                disabled: true,
                class: _normalizeClass({ 'phone-disabled': _ctx.isSmsSent })
              }, null, 8, ["modelValue", "placeholder", "class"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Field, {
                  modelValue: _ctx.formData.phoneVerificationCode2,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.phoneVerificationCode2 = $event)),
                  type: "text",
                  name: "phoneVerificationCode2",
                  placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.smsCode`),
                  "cy-data": "sms-code",
                  "is-numeric": true
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.smsCode`)), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RecaptchaButton, {
              action: _ctx.Action.DESKTOP_SMS,
              "data-testid": "btn-confirmPhone-resendCode",
              data: _ctx.formData,
              "button-type": "button",
              class: "resend-code",
              onSuccessSubmit: _ctx.handleSubmitSuccess
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.didntGetSmsOne`)) + " ", 1),
                _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.didntGetSmsTwo`)) + " »", 1)
              ]),
              _: 1
            }, 8, ["action", "data", "onSuccessSubmit"]),
            _createVNode(_component_SubmitButton, {
              action: _ctx.Action.CONFIRM_SMS_CODE,
              data: _ctx.formData,
              "data-testid": "btn-confirmPhone-confirm",
              class: "button submit-button",
              style: _normalizeStyle({ 'margin-bottom': _ctx.isSmsSent ? '-11px' : '0' }),
              disabled: !_ctx.formData.phoneVerificationCode2.length,
              onClick: _cache[5] || (_cache[5] = 
                        () =>
                            _ctx.amplitudeSendEvent(
                                _ctx.AmplitudeAnalyticsEvents.phoneNumber
                                    .PHONE_NUMBER_SMS_CONTINUE
                            )
                    )
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.confirm`)), 1)
              ]),
              _: 1
            }, 8, ["action", "data", "style", "disabled"]),
            (_ctx.formData.sentSmsCount >= 2)
              ? (_openBlock(), _createBlock(_component_RecaptchaButton, {
                  key: 0,
                  action: _ctx.Action.VERIFY_EMAIL,
                  "data-testid": "btn-confirmPhone-verificationByEmail",
                  data: _ctx.formData,
                  "button-type": "button",
                  class: "verification-by-email"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.unableToVerifyBySmsOne`)) + " - ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.unableToVerifyBySmsTwo`)) + " »", 1)
                  ]),
                  _: 1
                }, 8, ["action", "data"]))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "fix-phone-number",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isSmsSent = false))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneOne`)) + " - ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.wrongPhoneTwo`)) + " »", 1)
            ])
          ])
        ], 32))
      : _createCommentVNode("", true)
  ]))
}